import { IActionContext } from '@msdyn365-commerce/core';

export const makeAbsUrl = (context: IActionContext, url: string) => {
    if (url[0] === '/') {
        return `https://${window.location.host}${url}`;
    }

    return url;
};
